import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { MessageCircle, ExternalLink } from "lucide-react";

export function WhatsAppAdvanceModal({ open, data, onClose, onConfirm }) {
  if (!open || !data) return null;
  const { texto, link, contact, proximaEtapaLabel } = data;
  const openLink = () => {
    if (link) window.open(link, "_blank");
  };
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-md" data-testid="wa-advance-modal">
        <DialogHeader>
          <DialogTitle className="text-zinc-100 text-base font-semibold flex items-center gap-2">
            <MessageCircle className="h-4 w-4 text-green-500" />
            WhatsApp — {contact?.nome}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          {texto ? (
            <div>
              <p className="text-[11px] font-semibold text-zinc-500 uppercase tracking-wider mb-1">Mensagem sugerida</p>
              <div className="bg-zinc-900 border border-zinc-800 rounded-md p-3 text-xs text-zinc-200 whitespace-pre-wrap max-h-56 overflow-y-auto" data-testid="wa-texto">
                {texto}
              </div>
            </div>
          ) : (
            <p className="text-xs text-zinc-500">Sem script configurado. O WhatsApp abrirá sem texto pré-preenchido.</p>
          )}

          <Button onClick={openLink} data-testid="wa-abrir-btn" className="w-full bg-green-500 hover:bg-green-600 text-zinc-950 h-9 text-sm font-semibold">
            <ExternalLink className="h-4 w-4 mr-1.5" /> Abrir conversa no WhatsApp
          </Button>

          <div className="pt-3 border-t border-zinc-800">
            <p className="text-xs text-zinc-400 mb-2">Mensagem enviada?</p>
            <div className="flex gap-2">
              <Button onClick={onClose} className="flex-1 bg-zinc-800 hover:bg-zinc-700 h-8 text-xs" data-testid="wa-cancel">
                Agora não
              </Button>
              <Button onClick={onConfirm} data-testid="wa-confirm-btn" className="flex-1 bg-amber-500 hover:bg-amber-600 text-zinc-950 h-8 text-xs font-semibold">
                Sim, avançar{proximaEtapaLabel ? ` → ${proximaEtapaLabel}` : ""}
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
